import { create } from "zustand";

interface StopFunctionState {
  stopFunction: (() => void) | null;
  setStopFunction: (stopFn: (() => void) | null) => void;
}

const useStopFunctionStore = create<StopFunctionState>((set) => ({
  stopFunction: null,
  setStopFunction: (stopFn) => set({ stopFunction: stopFn }),
}));

export { useStopFunctionStore };
